
export const fetchClientStatus = async (token) => {
    try {
        // Fetch securely from our Serverless Endpoint (bypasses RLS limits)
        const res = await fetch(`/api/get-status?token=${token}`);
        const result = await res.json();

        if (!res.ok) {
            throw new Error(result.error || "Failed to fetch client status");
        }

        return result;
    } catch (err) {
        console.error("Error fetching client status:", err.message);
        return null;
    }
};

export const submitIntakeForm = async (token, clientData, formData) => {
    const res = await fetch('/api/submit-intake', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            token,
            clientName: clientData?.name || clientData?.client_name,
            company: clientData?.company,
            data: formData
        })
    });
    const result = await res.json();
    if (!res.ok) throw new Error(result.error || 'Failed to submit intake');
    return result;
};

export const submitCredentials = async (token, clientData, credentials) => {
    const res = await fetch('/api/submit-credential', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            token,
            clientName: clientData?.name || clientData?.client_name,
            company: clientData?.company,
            credentials
        })
    });
    const result = await res.json();
    if (!res.ok) throw new Error(result.error || 'Failed to submit credentials');
    return result;
};

export const completeStep = async (token, clientData, stepId) => {
    const res = await fetch('/api/complete-step', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            token,
            clientName: clientData?.name || clientData?.client_name,
            company: clientData?.company,
            stepId
        })
    });
    const result = await res.json();
    if (!res.ok) throw new Error(result.error || 'Failed to complete step');
    return result;
};

export const submitSupportRequest = async (token, clientData, message) => {
    const res = await fetch('/api/submit-support', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            token,
            clientName: clientData?.name || clientData?.client_name,
            company: clientData?.company,
            message
        })
    });
    const result = await res.json();
    if (!res.ok) throw new Error(result.error || 'Failed to submit support request');
    return result;
};
